/* eslint-disable ssr-friendly/no-dom-globals-in-module-scope */

const findNearestScroller = element => {
    while (element.parentElement) {
        element = element.parentElement
        const className = element.className.trim()

        if (className === "box" || className === "app-scroll-view__inner") {
            return element
        }
    }

    return null
}

window.oncontextmenu = e => {
    if (
        ["INPUT", "TEXTAREA"].includes(e.target.tagName) &&
        !["radio", "checkbox"].includes(e.target.type)
    ) {
        e.preventDefault()
        e.stopPropagation()

        return false
    }
}

// FIX SCROLLING-ISSUE

// Do not apply this to iOS 13 and above:
const isNewIOS =
    /iPhone OS (13|14|15|16|17|18)/i.test(navigator.userAgent) ||
    (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream)

document.addEventListener("focusin", e => {
    if (
        ["INPUT", "TEXTAREA"].includes(e.target.tagName) &&
        !["radio", "checkbox"].includes(e.target.type)
    ) {
        try {
            if (findNearestScroller(e.target)) {
                setTimeout(() => {
                    if (!isNewIOS) {
                        e.target.parentElement.parentElement.scrollIntoView({
                            behavior: "smooth",
                            block: "start",
                        })
                    } else {
                        e.target.parentElement.parentElement.scrollIntoView({
                            behavior: "smooth",
                            block: "center",
                        })
                    }
                }, 200)
            }
        } catch (e) {
            // swallow
        }
    }
})
